import { render, staticRenderFns } from "./CommunicationTab.vue?vue&type=template&id=4be6796a&scoped=true&"
import script from "./CommunicationTab.vue?vue&type=script&lang=ts&"
export * from "./CommunicationTab.vue?vue&type=script&lang=ts&"
import style0 from "./CommunicationTab.vue?vue&type=style&index=0&id=4be6796a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be6796a",
  null
  
)

export default component.exports